<template>
  <div>
    <!-- <pre>{{repository_id}}</pre> -->
    <form data-vv-scope="Room" class="px-4">
      <!-- {{repository_id}} -->
      <div class="vx-row">
        <div class="vx-col w-full">
          <div class="mb-4">
            <vs-input
              label="Room Name"
              class="w-full requiredInput"
              v-model="name"
              v-validate="'required'"
              data-vv-name="room name"
            />
            <div
              v-if="errors.has('Room.room name')"
              style="color: red"
              class="invalid-feedback"
            >
              {{ errors.first("Room.room name") }}
            </div>
          </div>
          <!-- {{inventoryTypeList}}
          {{old_non_removable_inventory_list}}
 {{non_removable_inventory_list}} -->
          <label class="vs-input--label">Inventory List</label>
          <v-select
            class="mb-4"
            :options="inventoryTypeList"
            label="name"
            v-model="non_removable_inventory_list"
            :reduce="(item) => item.assets_id"
            data-vv-name="inventory_type"
            multiple
          >
            <template v-slot:option="option">
              <div class="flex align-center">
                <img
                  src="https://maestroselectronics.com/wp-content/uploads/2017/12/No_Image_Available.jpg"
                  height="60"
                  width="60"
                />
                {{ option.name }}
              </div>
            </template>
          </v-select>

          <div class="mb-4">
            <vs-input
              label="Number of Person"
              class="w-full requiredInput"
              v-model="number_of_person"
              v-validate="'required|numeric'"
              data-vv-name="number of person"
            />
            <div style="color: red" class="invalid-feedback">
              {{ errors.first("Room.number of person") }}
            </div>
          </div>

          <div class="suitableTagHolder focusHolder mb-4">
            <label class="w-full vs-input--label">Suitable For (Type the name and press enter)</label>
            <span
              class="tag-badge"
              v-for="(suitableTag, index) in suitable_for"
              :key="index"
            >
              <span>{{ suitableTag }}</span>
              <a @click="deleteTag(index)">&times;</a>
            </span>
            <vs-input class="w-full" v-model="suitable" @keyup.enter="addTags" />
          </div>
          <div class="flex flex-wrap focusHolder">
            <div class="sm:w-1/2 w-full mb-4">
              <vs-input
              label="Price Booking"
                class="w-full pr-2 requiredInput"
                v-model="price"
                v-validate="'required|numeric'"
                data-vv-name="price"
              />
              <div
                v-if="errors.has('Room.price')"
                style="color: red"
                class="invalid-feedback"
              >
                {{ errors.first("Room.price") }}
              </div>
            </div>
            <!-- {{booking_time_array}} -->
            <div class="sm:w-1/2 w-full mb-4">
              <label class="w-full vs-input--label">Select rate based on<span class="required"></span></label>
              <v-select
                class="w-full requiredInput"
                v-model="price_type"
                :options="booking_time_array"
                label="name"
                :reduce="(option) => option.id"
                style="width: 100%"
                v-validate="'required'"
                data-vv-name="price_type"
                name="price_type"
              />
              <div
                v-if="errors.has('Room.price_type')"
                style="color: red"
                class="invalid-feedback"
              >
                {{ errors.first("Room.price_type") }}
              </div>
            </div>
          </div>

             <div>
            <label class="vs-input--label">Attach Images</label>
<!-- {{oldImages}}
  v-if="
                editingObject &&
                files &&
                oldImages.length
              "
 -->
 <!-- <pre>{{files}}</pre> -->
            <div
              class="flex flex-wrap align-center"
              v-if="files.length"
            >
              <div
                v-for="(eachImage, index) in files"
                :key="index"
                style="margin:5px"
              >
              <vs-radio v-model="eachImage.is_default" vs-name="radios" vs-value="1"
              @change="selectDefaultImage(index)"
              />
                <vs-card class="imageholdercontainer">
                  <img
                    :src="eachImage.file_image_url"
                    width="200"
                    height="200"
                  />
                  <vs-tooltip text="Remove this Picture">
                    <vs-button
                      radius
                      color="primary"
                      type="border"
                      icon="delete"
                      class="deleteIcon"
                      @click="deleteFile(index, eachImage)"
                    ></vs-button>
                  </vs-tooltip>
                </vs-card>
              </div>
            </div>
          </div>
          <!-- <pre>{{files}}</pre> -->
          <file-upload-component
            types="Room"
            :files="files"
            :deletedFile="deletedFile"
            @getImage="getImage"
            @removeImageEvent="removeImage"
            :file_repository_id="repository_id"
          ></file-upload-component>
        </div>
      </div>

      <div class="flex mt-5 justify-end">
        <vs-button
          color="primary"
          type="filled"
          style="font-size: 13.8px; padding: 9px"
          class="mr-3"
          @click="createNewRoom()"
        >
          <span v-if="!editingObject">Create Room</span>
          <span v-else>Update Room</span>
        </vs-button>
        <vs-button
          color="danger"
          type="filled"
          style="font-size: 13.8px; padding: 9px"
          class="mr-3"
          @click="handleCloseSidebar()"
          >Cancel</vs-button
        >
      </div>
    </form>
  </div>
</template>

<script>
import { createRoomApi, updateRoom } from '@/api/room.js'
import { roomInventory } from '@/mixins/Rooms/roomInventory.js'
import { repository } from '@/mixins/repository'

import vSelect from 'vue-select'
import FileUploadComponent from '../FileUploadComponent.vue'
export default {
  components: {
    vSelect,
    FileUploadComponent
  },
  name: 'RoomCreate',
  mixins: [roomInventory, repository],
  data () {
    return {
      asset_types: 'Room',
      assets_id: null,
      category_id: '',
      old_non_removable_inventory_list:[],
      booking_time_array:[
        {
          id:1,
          name:'Daily'
        
        },
        {
          id:2,
          name:'Hourly'
        
        },
        {
          id:3,
          name:'Monthly'
        
        }
        
      ]
      
    }
  },
  props: {
    editingObject: {
      default: () => null
    }
  },

  created () {
    
    this.getRepositoryId(this.ASSETS_MODULE)
    this.fetchingInventoryType()
    if (this.editingObject) {
      
      
      this.assets_id = this.editingObject.assets_id
      this.oldImages = [...this.editingObject.asset_images]

      //   this.asset_details = this.editingObject.asset_details
      // =this.editingObject.asset_images
      // =this.editingObject.asset_tags
      this.inventory_type = this.editingObject.inventory_type
      this.name = this.editingObject.name
      this.price = this.editingObject.price
      this.price_type = this.editingObject.price_type
      this.quantity = this.editingObject.quantity
      this.number_of_person = this.editingObject.number_of_person
      this.suitable_for = this.editingObject.asset_tags.map(
        (ele) => ele.tag_name
      )
      //   
      this.non_removable_inventory_list = this.editingObject
        .non_removable_inventory_list
        ? this.editingObject.non_removable_inventory_list.map(
          (ele) => ele.asociated_assets_id
        )
        : []
      this.old_non_removable_inventory_list = this.non_removable_inventory_list
      this.files = this.editingObject.asset_images.map((ele) => {
        return {
          files_id: ele.files_id,
          files_repository_id: ele.files_repository_id,
          file_image_url:ele.files_details.file_path,
          is_default:ele.is_default
        }
      })
    } else {
      
    }
  },

  methods: {
    async createNewRoom () {
      const validateParent = this.$validator.validateAll('Room')

      validateParent.then((valid) => {
        if (valid) {
          /*  if (this.files.length === 0) {
            this.showSuccessMessage(
              'Warning',
              'Atleast Attached One files',
              'danger'
            )
          }  */
          //checing Default changes
       

          //checking default value

          const hasCheckingDefault = this.checkingDefaultValue()

          if (hasCheckingDefault) {
             
            this.creatingNewInventory()

          } else {
            this.showSuccessMessage(
              'Warning',
              'Please select image as default image',
              'danger'
            )
          }
            

        } else {
          this.showSuccessMessage(
            'Warning',
            'Validation Field is Required',
            'danger'
          )
        }
      })
    },
    async creatingNewInventory () {
      const customer_id = this.$store.getters.customerId
      let text = ''
      if (!this.editingObject) {
        text = 'Creating New Room'
      } else {
        text = 'Updating Room ...'
      }
      try {
        this.$vs.loading({
          text
        })
        const payload = {
          customer_id,
          name: this.name,
          non_removable_inventory_list: this.non_removable_inventory_list,
          asset_types: this.asset_types,
          price: this.price,
          quantity: this.quantity,
          suitable_for: this.suitable_for,
          files: this.files,
          price_type: this.price_type,
          number_of_person: this.number_of_person,
          inventory_type: 2
        }
        /*  if (this.inventory_type === 1) {
            payload.quantity = 1
            } else {
            delete payload.asset_codes
            } */
        
        if (this.assets_id) {
          payload.assets_id = this.assets_id

          //checking nonremovable changes

          const checking = this.checkingNonRemovable()

          if (checking) {
            delete payload.non_removable_inventory_list
          }

          const response = await updateRoom(payload)
          // 
          this.$emit(
            'createdNewInventory',
            response.data.data.assets_details,
            this.assets_id
          )
          this.showSuccessMessage(
            'Success',
            'Room Updated successfully',
            'success'
          )
        } else {
          const response = await createRoomApi(payload)
          
          //   

          this.showSuccessMessage(
            'Success',
            'New Room Created successfully',
            'success'
          )
          this.$emit('createdNewInventory', response.data.data.assets_details)
        }
      } catch (error) {
        
        if ('data' in error) {
          
          this.showSuccessMessage('Error', `${error.data.message}`, 'danger')
        }
        // 
      } finally {
        this.$vs.loading.close()
      }
    },
    handlcreateSidebar () {
      
    }
  },
  beforeDestroy () {
    this.assets_id = null
  }
}
</script>

<style scoped>
.category-pop {
  z-index: 999999999999999999999 !important;
}
.disabled {
  pointer-events: none;
  color: #bfcbd9;
  cursor: not-allowed;
  background-image: none;
  /* background-color: #eef1f6;
  border-color: #d1dbe5; */
}
.imageholdercontainer {
  position: relative;
}
.imageholdercontainer .deleteIcon {
  position: absolute;
  top: 0;
  right: 0;
}
.required:after {
  content: " *";
  color: red;
}
</style>